<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="list-row shipping-row-list">
    <v-card
        @click="openShipping({shipping:shipping,shippings:$store.state.shipping.data,index:currentIndex})"
    >
      <v-row class="shipping-row">
        <v-col class=" ml-4">
          <span class="body-2 date-block" v-if="shipping.route && $helper.date_format_short(shipping.route.start_at) == $helper.date_format_short(shipping.route.end_at)">
            {{ shipping.route && $helper.date_format_short(shipping.route.start_at) }}
          </span>
          <span class="body-2 date-block" v-else>
            {{ shipping.route && $helper.day_format_short(shipping.route.start_at) }}-{{ shipping.route && $helper.date_format_short(shipping.route.end_at) }}
          </span>

          <span>{{ shipping.code }}</span>
          <span class="body-2">{{ shipping.route && shipping.route.cache_provinces && (" ("+shipping.route.cache_provinces+")") }}</span>
        </v-col>
        <v-col class="col-2 text-center">
          {{ shipping.route && shipping.route.truck && shipping.route.truck.plate }}
        </v-col>
        <v-col class="col-2 text-center">
          <v-btn tile :color="getStatusColor(shipping.status)">{{ map(shipping.status) }}</v-btn>
        </v-col>
        <v-col class="col-2 text-right mr-4">
          {{ $helper.number_format(shipping.total_cost, 2, 2) }}
          <div class="percent" v-if="shipping.route && shipping.route.total_worth"
                  :class="{
                  'text-green':shipping.total_cost/shipping.route.total_worth<=0.05,
                  'text-red':shipping.total_cost/shipping.route.total_worth>=0.10,
                  'text-yellow':shipping.total_cost/shipping.route.total_worth>0.05 && shipping.total_cost/shipping.route.total_worth<0.10,
                }"

            >
          {{$helper.number_format(100*shipping.total_cost/shipping.route.total_worth, 2, 2) }}%
            </div>
        </v-col>
      </v-row>
    </v-card>
  </div>

</template>
<style lang="scss" scoped>
.shipping-row-list {
  padding: 16px 12px 0;
}

.shipping-row {

  height: 65px;
  align-items: center;
  line-height: 1.2;
  font-size: 18px;

  .col {
    padding: 4px;
  }
}
.percent{
  font-size: 0.8em;
}

.text-green {
  color: #009900;
}

.text-yellow {
  color: #999900;
}

.text-red {
  color: #CC0000;
}
.date-block{
  display: inline-block;
  min-width: 90px;
}
@media (min-height: 700px) {
  .shipping-row {
    font-size: 22px;
  }
}

</style>

<script lang="ts">

import {Component, Prop, Vue} from 'vue-property-decorator'
import {Shipping, ShippingConst} from '../../models/Shipping'
import Helper from '../../services/Helper.js'

@Component({
  components: {}
})
export default class ShippingRow extends Vue {
  @Prop() shipping: Shipping
  @Prop() currentIndex: number

  ShippingConst = ShippingConst


  map(status) {
    return ShippingConst.map(status)
  }

  getStatusColor(status) {
    return ShippingConst.color(status)
  }

  //          {{ shipping.status>=ShippingConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO?$helper.date_format_short(shipping.erp_so_at):$helper.date_format_short(shipping.submitted_at)}}

  openShipping(option) {
    this.$root.$emit('openShipping', option)
  }
}

</script>
